import { useFetch } from '../useFetch';
import { useAuth } from '../../context';
export function useAuthFetch() {
    const { authService } = useAuth();
    return useFetch(authService.getAccessToken);
}
